import numeral from 'numeral';
import moment from 'moment';
function printValue(value, isPercent) {
    if (value === null || value === undefined) {
        return '-';
    }
    else {
        var val = typeof value === 'number' ? value : parseFloat(value);
        var suffux = isPercent ? ' %' : '';
        return numeral(val).format('0,0.00') + suffux;
    }
}
function formatDate(value, format) {
    if (format === void 0) { format = 'YYYY-MM-DD'; }
    if (value) {
        return moment(value).format(format);
    }
    else {
        return '-';
    }
}
export function isObject(value) {
    var type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}
export { printValue, formatDate };
//# sourceMappingURL=index.js.map